// extracted by mini-css-extract-plugin
module.exports = {"pressTopSection":"PressTopSection_pressTopSection__iAjLc","content":"PressTopSection_content__t0H0M","pressCall":"PressTopSection_pressCall__V5qmj"};